// BarcodeInput.tsx
import { TextInput, TextInputProps } from "@mantine/core";
import React from "react";

interface BarcodeInputProps extends TextInputProps {
  handleBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const BarcodeInput = ({ handleBlur, ...etcParams }: BarcodeInputProps) => {
  const [isComposing, setIsComposing] = React.useState(false);

  return (
    <TextInput
      auto-focus
      data-autofocus
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      translate="no"
      label={"바코드 정보 입력"}
      aria-label="바코드정보"
      placeholder="Enter Input And Take a Barcode "
      onCompositionStart={() => setIsComposing(true)}
      onCompositionEnd={(e) => {
        setIsComposing(false);
      }}
      {...etcParams}
      onBlur={(e) => {
        etcParams.onBlur && etcParams.onBlur(e);
        // IME 조합 중 블러되는 경우 방지
        if (!isComposing) handleBlur && handleBlur(e);
      }}
    />
  );
};
